import { render, staticRenderFns } from "./SecretCreateDialog.vue?vue&type=template&id=2fdd6cee&"
import script from "./SecretCreateDialog.vue?vue&type=script&lang=js&"
export * from "./SecretCreateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports